<template>
<div class="chapter">
<div class="inner_page">
<p class="fn-title"><span>COLGATE &amp; CO’S</span></p>
<p class="fn-title1"><span>FLAVORING EXTRACTS,</span></p>
<p class="fn-title2"><span>SUPERIOR</span></p>
<p class="fn-title3"><span>-<span class="smallcaps">IN</span>-</span></p>
<p class="fn-title2"><span>P<span class="smallcaps">URITY AND</span> S<span class="smallcaps">TRENGTH.</span></span></p>
<p class="image-center"><span><img alt="img" src="images/fm-line.jpg"/></span></p>
<p class="fn-title5"><span>EXTRACT VANILLA,</span></p>
<table border="0" cellpadding="0" cellspacing="1" rules="all" width="100%;">
<tbody><tr>
<td style="width:5%;"> </td>
<td style="width:10%;" valign="top"><p class="right-1">”</p></td>
<td style="width:30%;" valign="top"><p class="right">ROSE,</p></td>
<td style="width:5%;"> </td>
</tr>
<tr>
<td style="width:5%;"> </td>
<td style="width:10%;" valign="top"><p class="right-1">”</p></td>
<td style="width:30%;" valign="top"><p class="right">LEMON,</p></td>
<td style="width:5%;"> </td>
</tr>
<tr>
<td style="width:5%;"> </td>
<td style="width:10%;" valign="top"></td>
<td style="width:30%;" valign="top"><p class="right">ORANGE,</p></td>
<td style="width:5%;"> </td>
</tr>
<tr>
<td style="width:5%;"> </td>
<td style="width:10%;" valign="top"></td>
<td style="width:30%;" valign="top"><p class="right">ALMOND,</p></td>
<td style="width:5%;"> </td>
</tr>
<tr>
<td style="width:5%;"> </td>
<td style="width:10%;" valign="top"></td>
<td style="width:30%;" valign="top"><p class="right">GINGER,</p></td>
<td style="width:5%;"> </td>
</tr>
<tr>
<td style="width:5%;"> </td>
<td style="width:10%;" valign="top"></td>
<td style="width:30%;" valign="top"><p class="right">CELERY.</p></td>
<td style="width:5%;"> </td>
</tr>
</tbody></table>
<p class="indent3">The same high standard of excellence is observed in the preparation of our Flavoring Extracts which has made <span class="underline">all articles</span> of our manufacture so popular.</p>
<p class="right5"><span>Colgate &amp; Co.,</span></p>
<p class="right2"><span>55 JOHN STREET, N. Y.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter1.vue?76323aa9